import { Model } from './model';

export class Grade extends Model {
  name: string;
  isSelected: boolean;
}
